namespace GeniuzPOS.Lookups {
    export interface LookupBrandRow {
        Id?: number;
        BrandCode?: string;
        BrandName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace LookupBrandRow {
        export const idProperty = 'Id';
        export const nameProperty = 'BrandCode';
        export const localTextPrefix = 'Lookups.LookupBrand';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
